import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

declare const HomePageLoad: any;
declare function HomevoiceOnKeyPress(value, key): any;
declare function HomeresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
//declare function keydown(key): any;
declare const VoiceForLoginUser: any;
declare var $: any;

@Component({
  selector: 'app-dachomepage',
  templateUrl: './dachomepage.component.html',
  styleUrls: ['./dachomepage.component.css']
})
export class DachomepageComponent implements OnInit {

  route: string;
  pathname = '';
  constructor(private router: Router) {
   
  }

  onKeyUp(event: any) {
    debugger;
    if (event.target.id == "registration" && event.keyCode == 13) {
      if (sessionStorage.length == 1) {
        VoiceForLoginUser();
      }
      else {
        this.router.navigate(['/registration']);
      }
      return;
    }
    if (event.keyCode == 9 || event.keyCode == 13) {
      // add voice message on firefox and chrome
      if (event.target.id == "lblDACForIssuersandObligors" && event.keyCode != 13) {
        HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
      else
        if (event.target.id == "lblDACForIssuersandObligors" && event.keyCode == 9) {
          HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
        else if (event.target.id != "lblDACForIssuersandObligors" && event.keyCode == 9) {
          HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }

      //if (event.target.id == "lblDACForIssuersandObligors" && event.keyCode != 13) {
      //  HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      //}
    }
    //$(document).ready(function () {
    //  debugger;
    //  var lastIndex = 0;
    //  var startIndex = 1;
    //  var tabLimitInID;
    //  $(document).keydown(function (e) {
    //    debugger;
    //    if (e.keyCode == 9) var thisTab = $(":focus").attr("tabindex");
    //    if (e.keyCode == 9) {
    //      if (e.shiftKey) {
    //        //Focus previous input
    //        if (thisTab == startIndex) {
    //          $("." + tabLimitInID).find('[tabindex=' + lastIndex + ']').focus();
    //          return false;
    //        }
    //      } else {
    //        if (thisTab == lastIndex) {
    //          $("." + tabLimitInID).find('[tabindex=' + startIndex + ']').focus();
    //          return false;
    //        }
    //      }
    //    }
    //  });
    //  var setTabindexLimit = function (x, fancyID) {
    //    console.log(x);
    //    startIndex = 1;
    //    lastIndex = x;
    //    tabLimitInID = fancyID;
    //    $("." + tabLimitInID).find('[tabindex=' + startIndex + ']').focus();
    //  }
    //  setTabindexLimit(29, "limitTablJolly");
    //});
  };

  onClick(event: any) {
    debugger;
    if (sessionStorage.length == 1) {
      alert("You are already logged in. Logout to enter this page.");
    }
    else {
      this.router.navigate(['/registration']);
    }
    return;
  }

  onkeypress(event: any) {
    //debugger;
    
    
    //HomevoiceOnKeyPress(event.target.value, event.key);
  }


  
  ngOnInit() {
    debugger;
    document.getElementById("pageloadid").focus();   
    //=========Caption Hide Show=============//
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }
    //============Voice Annotation On/Off=========
    if ($('#hidVoiceOnOff').val() == "OFF") {
      $('#btnVoiceAnnotation').val('OFF');
      $('#hidVoiceOnOff').val('OFF');
      //$('#btnPlayPause').attr('src', ('assets/images/pause.png'));
      $('#btnPlayPause').css('display', 'none');
    }
    else {
      $('#btnVoiceAnnotation').val('ON');
      $('#hidVoiceOnOff').val('ON');
      //$('#btnPlayPause').attr('src', ('assets/images/play-button.png'));
      $('#btnPlayPause').css('display', 'block');
    }

    HomePageLoad();
    
    document.getElementById("homePageTab").style.display = "none";  
  }
}
